import { autoinject } from "aurelia-framework";
import { ITranscript } from "../../../interfaces/audio/i-audio";
import { ScheduleStatusEnum } from "../../../enums/schedule-status-enum";
// Singleton (default Aurelia DI lifetime): shared between the toggle button in the patient
// header and the panel rendered alongside the note content, since they're no longer in the
// same part of the DOM.

export const TRANSCRIPT_HIDDEN_STATUSES: ScheduleStatusEnum[] = [
    ScheduleStatusEnum.SubmittedCoSignature,
    ScheduleStatusEnum.SubmittedWithSignature,
    ScheduleStatusEnum.Completed,
];
@autoinject
export class TranscriptPanelState {
   public isOpen: boolean = false;
   public isExpanded: boolean = false;
   public transcript: ITranscript = null;

   public open() {
       this.isOpen = true;
   }

   public close() {
       this.isOpen = false;
       this.isExpanded = false;
   }

   public toggleOpen() {
       if (this.isOpen) {
           this.close();
       } else {
           this.open();
       }
   }

   public toggleExpanded() {
       this.isExpanded = !this.isExpanded;
   }

   public reset() {
    this.close();
    this.transcript = null;
   }
}